module.exports = __webpack_public_path__ + "img/ec.4823f2ed.svg";